import { InputWithButtonProps } from '@/shared/types/CommonTypes';
import { cn } from '@/shared/utils/cn';

const InputWithButton = ({
  label,
  error,
  buttonText,
  onButtonClick,
  buttonDisabled,
  rightElement,
  fullWidth = true,
  className,
  ref,
  ...props
}: InputWithButtonProps) => {
  return (
    <div className={cn('text-left', fullWidth && 'w-full')}>
      {label && (
        <label
          htmlFor={props.id || props.name}
          className="ml-2 text-[14px] font-semibold leading-[1.4] text-[#444]"
        >
          {label}
        </label>
      )}

      <div className="relative">
        <input
          ref={ref}
          className={cn(
            'mt-1 h-10 rounded-full border border-[#ddd] px-6 pr-[120px] text-[14px] text-[#444] focus:outline-none',
            fullWidth && 'w-full',
            error && 'border-red-500',
            className,
          )}
          {...props}
        />

        {rightElement && (
          <div className="absolute right-[112px] top-4">{rightElement}</div>
        )}
        <button
          type="button"
          disabled={buttonDisabled}
          onClick={onButtonClick}
          className="absolute right-1 top-1 mt-1 h-8 w-[100px] cursor-pointer rounded-full border border-[#b995be] bg-[#fff] text-[14px] font-medium text-[#b995be] hover:border-0 hover:bg-[#b995be] hover:text-[#fff] disabled:cursor-not-allowed disabled:opacity-50"
        >
          {buttonText}
        </button>
      </div>

      {error && <p className="ml-2 mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default InputWithButton;
